import { setBlockPropAtPath } from './siteBlocks';
import { getPropAtPath } from './puckContentPath';
import { checkpointRichTextHistory } from './puckRichTextHistory';

/**
 * Écrit le HTML Tiptap dans l'état Puck (même flux que InlineTextField natif).
 * @returns {boolean} true si un replace a été dispatché
 */
export function syncRichTextToPuck({
  id,
  contentProp,
  contentPath,
  nextHtml,
  getItemById,
  getSelectorForId,
  dispatch,
  history,
  appState,
}) {
  const item = getItemById(id);
  const sel = getSelectorForId(id);
  if (!item || !sel || typeof sel.index !== 'number' || sel.index < 0 || !sel.zone) {
    return false;
  }

  const propPath = contentPath || contentProp;
  const currentValue = getPropAtPath(item.props, contentProp, contentPath);
  if (nextHtml === currentValue) return false;

  checkpointRichTextHistory(history, appState);
  const newProps = setBlockPropAtPath(item.props, propPath, nextHtml);
  dispatch({
    type: 'replace',
    destinationIndex: sel.index,
    destinationZone: sel.zone,
    data: {
      type: item.type,
      props: newProps,
    },
    recordHistory: true,
  });
  return true;
}
